import React from "react";
import {
  Typography,
  ListItem,
  ListItemText,
  Box,
  Avatar,
  Tooltip,
} from "@material-ui/core";
import { get, upperCase } from "lodash";
import { useStyles } from "./styles";
import { useHistory } from "react-router";
import {
  TARGET,
  USERPROFILE,
  OVERVIEW,
  CHECKIN,
  REPORTS,
  SUCCESS_STORIES,
  PERFORMANCE_REVIEW,
  CHECKINHIGHLIGHTED,
} from "../../constants/routeConstants";
import { TargetDefault } from "Assets/images";
import { useMainTheme } from "Hooks/useMainTheme";
import PRIcon from "Assets/images/notif-pr.svg";
import SSIcon from "Assets/images/notif-ss.svg";
import UserProfileWidget from "Components/widgets/UserProfileWidget";

const SearchListItem = ({
  notification,
  setSearchOptions,
  setInputText,
  setAnchorEl,
}) => {
  const styleProps = useMainTheme();
  const classes = useStyles(styleProps);
  const history = useHistory();
  const altText = (search) => {
    return get(search, "type", "") === "User"
      ? `${upperCase(
          get(search, "name", "")
            .split(" ")
            .map((n, i) => {
              if (i < 2) {
                return n[0];
              }
            })
            .join("")
        )}`
      : `${upperCase(get(search, "name", "").split(" ")[0][0])}`;
  };

  const handleOnClick = (notifications) => {
    const type = get(notifications, "type", "");
    switch (type) {
      case "User":
        window.open(`${USERPROFILE}/${get(notifications, "id", "")}`);
        break;
      case "Target":
        window.open(`${TARGET}${OVERVIEW}/${get(notifications, "id", "")}`);
        break;
      case "Checkin": {
        if (notification?.showCheckinDetails)
          window.open(
            `${TARGET}${OVERVIEW}/${get(
              notifications,
              "targetId",
              ""
            )}${CHECKIN}/${get(notifications, "id", "")}`
          );
        else
          window.open(
            `${TARGET}${OVERVIEW}/${get(
              notifications,
              "targetId",
              ""
            )}${CHECKINHIGHLIGHTED}/${get(
              notifications,
              "id",
              ""
            )}?&currentTab=checkin`
          );
        break;
      }
      case "SuccessStory":
        notifications?.isPerformanceReview
          ? window.open(
              `${REPORTS}${PERFORMANCE_REVIEW}/${get(notifications, "id", "")}`
            )
          : window.open(
              `${REPORTS}${SUCCESS_STORIES}/${get(notifications, "id", "")}`
            );
        break;
      default:
        break;
    }
    setSearchOptions([]);
    setInputText("");
    setAnchorEl(null);
  };

  const getImage = (notification) => {
    const type = get(notification, "type", "");
    switch (type) {
      case "User":
        return (
          <Box
            className={classes.userImgWrapper}
            display="flex"
            justifyContent="center"
          >
            <UserProfileWidget
              firstName={get(notification, "firstName", "")}
              lastName={get(notification, "lastName", "")}
              url={get(notification, "image", "")}
              status={get(notification, "status", "")}
            />
            {/* <Avatar className="avatar-img">
              <img
                src={
                  (get(notification, "image", "") || "").includes(
                    process.env.REACT_APP_CLOUD_FRONT_URL
                  )
                    ? get(notification, "image", "")
                    : `${process.env.REACT_APP_CLOUD_FRONT_URL}/${get(
                        notification,
                        "image",
                        ""
                      )}`
                }
                alt={altText(notification)}
              />
            </Avatar> */}
          </Box>
        );
      case "Target":
        return (
          <Box className={classes.targetImg}>
            <img
              src={get(notification, "image", "")}
              alt="target image"
              className={classes.targetImg}
            />
          </Box>
        );
      case "Checkin":
        return (
          <Box className={classes.checkinImgWrapper}>
            <img
              src={get(notification, "image", "")}
              alt="target image"
              className={classes.checkinImg}
            />
          </Box>
        );
      case "SuccessStory":
        return (
          <Box className={classes.checkinImgWrapper}>
            {notification?.isPerformanceReview ? (
              <img
                src={PRIcon}
                alt="performance review image"
                className={classes.checkinImg}
              />
            ) : (
              <img
                src={SSIcon}
                alt="success story image"
                className={classes.checkinImg}
              />
            )}
          </Box>
        );
      default:
        break;
    }
  };

  const getDefaultImage = (notification) => {
    const type = get(notification, "type", "");
    switch (type) {
      case "User":
        return (
          <Box
            className={classes.userImgWrapper}
            display="flex"
            justifyContent="center"
          >
            {/* <Avatar className="avatar-img avatar-bg">
              {altText(notification)}
            </Avatar> */}
            <UserProfileWidget
              firstName={get(notification, "firstName", "")}
              lastName={get(notification, "lastName", "")}
              url={get(notification, "image", "")}
              status={get(notification, "status", "")}
            />
          </Box>
        );
      case "Target":
        return (
          <Box className={classes.targetImg}>
            <img
              src={TargetDefault}
              alt="target image"
              className={classes.targetImg}
            />
          </Box>
        );
      case "Checkin":
        return (
          <Box className={classes.checkinImgWrapper}>
            <img src={""} alt="Check-in image" className={classes.checkinImg} />
          </Box>
        );
      case "SuccessStory":
        return (
          <Box className={classes.checkinImgWrapper}>
            {notification?.isPerformanceReview ? (
              <img
                src={PRIcon}
                alt="performance review image"
                className={classes.checkinImg}
              />
            ) : (
              <img
                src={SSIcon}
                alt="success story image"
                className={classes.checkinImg}
              />
            )}
          </Box>
        );
      default:
        break;
    }
  };

  return (
    <ListItem data-testid="list" onClick={() => handleOnClick(notification)}>
      <ListItemText>
        <Box display="flex" alignItems="center">
          {(get(notification, "image", "") || "").length ||
          get(notification, "image", "") === "SuccessStory"
            ? getImage(notification)
            : getDefaultImage(notification)}
          <Tooltip title={get(notification, "name", "")}>
            <Typography variant="body2" className="font-13 truncate-txt">
              {get(notification, "name", "")}
            </Typography>
          </Tooltip>
        </Box>
      </ListItemText>
    </ListItem>
  );
};

export default SearchListItem;
